export enum FEATURE_CREATION_OPTION {
  UPDATE_FEATURE_INFORMATION = 'updateFeatureInformation',
}
